export function useRobotsPathConfig() {
    const { path } = useRoute();

    const pathsWithoutIndex: (string|RegExp)[] = [
        '/account',
        '/account/login',
        '/account/register',
        /^\/account\/order\/edit\//,
        '/account/orders',
        '/account/payment',
        '/account/profile',
        '/account/address',
        /^\/checkout\/finish\//,
        '/checkout/cart',
        '/checkout/confirm',
        '/search',
    ];

    const isRobotsNoIndex = computed(() => {
        return pathsWithoutIndex.some((currentPath) => {
            // check regular expression or string
            if (typeof currentPath === 'string') {
                return path === currentPath;
            } else {
                return currentPath.test(path);
            }
        });
    });


    return { isRobotsNoIndex };
}
